import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import style from 'routes/score/lol/view/style.module.scss';
import clsx from 'clsx';
import LolViewSet from './SetDetails';
import { _E_SPORTS_GAME_STATUS } from 'common/constants/sportsConstants';

const LolBroadCast = observer(({ gameData }) => {
  const { detail } = gameData;
  const { sets, getTabs, gameStatus } = detail;
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [setLength, setSetLength] = useState(0);

  useEffect(() => {
    if (sets?.length > setLength) {
      setSetLength(sets.length);
      setTabs(getTabs);

      if (gameStatus === 'IN_PROGRESS') {
        const sliceTab = sets.slice();
        const checkProgress = sliceTab.some((a) => _E_SPORTS_GAME_STATUS[a.sstatus] === 'IN_PROGRESS');
        let progressTab = 1;

        if (checkProgress) {
          progressTab = sliceTab.filter((set) => _E_SPORTS_GAME_STATUS[set.sstatus] === 'IN_PROGRESS').pop().snum;
        } else {
          const readyTab = sliceTab.filter((set) => _E_SPORTS_GAME_STATUS[set.sstatus] === 'READY');

          if (readyTab.length > 0) {
            progressTab = readyTab[0].snum;
          }
        }

        setSelectedTab(progressTab);
      } else {
        setSelectedTab(1);
      }
    }
  }, [sets, getTabs, gameStatus]);

  return (
    <>
      {setLength > 0 && (
        <div className={style.set_score}>
          <ul className={style.tab}>
            {tabs?.map((item) => {
              return (
                <li className={clsx(item.key === selectedTab && style.on)} key={item.key}>
                  <button disabled={item.disabled} onClick={() => setSelectedTab(item.key)}>
                    {item.value}
                  </button>
                </li>
              );
            })}
          </ul>
          <LolViewSet item={sets.filter((set) => set.snum === selectedTab)[0]} />
        </div>
      )}
    </>
  );
});

export default LolBroadCast;
